( function () {
	'use strict';

	function paging () {
		return function ( collection, pageStart, pageSize ) {
			if ( collection && collection.length > pageSize ) {
				collection = collection.slice( pageStart );
			} else {
				collection = collection;
			}

			return collection;
		};
	}

	angular
		.module( 'app.components' )
		.filter( 'paging', paging );
} )( );
